// 多天不上传统计
export default {
	header: {
		pic: 'statistical-analysis',
		title: '多天不上传统计',
		desc: '对多天不上传数据的设备进行统计分析。',
	},
	filterArr: [
		{
			title: '统计条件',
			filterList: [
				{
					key: 'manufacturerId',
					type: 'select',
					keyWord: '厂商名称',
				},
				{
					key: 'deviceTypeIdList',
					dicKey: 'deviceTypeId',
					type: 'select',
					keyWord: '设备类型',
					multiple: true,
				},
				{
					key: 'deviceNo',
					keyWord: '设备通讯编号',
				},
				{
					key: 'designNo',
					keyWord: '外观编号',
				},
				{
					key: 'day',
					keyWord: '不上传天数',
					unit: '天',
					required: true,
					default: 1,
				},
				{
					key: 'userNo',
					keyWord: '用户号',
				},
				{
					key: 'username',
					keyWord: '客户名称',
				},
			],
		},
	],
	formRules: {
		day: [
			{
				required: true,
				message: '请输入不上传天数',
				trigger: ['change', 'blur'],
			},
			{
				validator: (rule, value, callback) => {
					const reg = /^([0]|[1-9][0-9]*)$/
					if (!reg.test(value)) {
						callback(new Error('请输入正整数'))
						return
					}
					if (value < 0) {
						callback(new Error('请输入天数大于0'))
						return
					}
					if (value > 255) {
						callback(new Error('最大天数不能超过255'))
						return
					}
					callback()
				},
				trigger: ['change', 'blur'],
			},
		],
	},
	columns: [
		{
			key: 'manufacturerName',
			name: '厂商名称',
			tooltip: true,
		},
		{
			key: 'deviceTypeName',
			name: '设备类型',
			tooltip: true,
		},
		{
			key: 'deviceNo',
			name: '设备通讯编号',
		},
		{
			key: 'installDate',
			name: '安装日期',
		},
		{
			key: 'designNo',
			name: '外观编号',
		},
		{
			key: 'lastCommunicationTime',
			name: '最后通讯日期',
			width: 180,
		},
		{
			key: 'userNo',
			name: '用户号',
		},
		{
			key: 'username',
			name: '客户名称',
		},
		{
			key: 'address',
			name: '安装地址',
			tooltip: true,
		},
	],
}
